"use strict";
/**
 * PDF Upload API Request/Response Types
 *
 * Types for the PDF upload, status, download, and remove endpoints.
 */
Object.defineProperty(exports, "__esModule", { value: true });
